import { useIntl } from "react-intl";

const useUnbilledAccounts = () => {
  const { messages } = useIntl();

  const headerConfig = {
    title: messages.label_not_invoiced,
  };

  return {
    headerConfig,
  };
};

export default useUnbilledAccounts;
